<template>
  <transition @enter="onEnter" @leave="onLeave" :css="false">
    <div v-cloak v-if="sharedState.activeOverlay === $options.name" class="menu-overlay">
      <div class="grid cf" data-menu-item>
        <div class="col-l col-7-l push-2-l pt7-l">
          <TagAutocomplete :focus="true" :theme-site="this.themeSite" :light-bg="this.lightBg" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import s from "../store"
import { handleMenuOverlayEnter, handleMenuOverlayLeave } from "./MenuOverlay"
import TagAutocomplete from "./TagAutocomplete.vue"

export default {
  name: "SearchNav",

  components: {
    TagAutocomplete
  },

  data() {
    return {
      sharedState: s.state
    }
  },

  props: {
    formAction: String,
    placeholder: String,
    text: String,
    themeSite: String,
    lightBg: {
      type: String,
      default: "false"
    }
  },

  methods: {
    onEnter: handleMenuOverlayEnter,
    onLeave: handleMenuOverlayLeave
  }
}
</script>

